import { useEffect, useState } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogViewToday = (screenName: string) => {
  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {
    if (isLogged) return;

    bridge.logAnalyticsEvent({
      name: 'VIEW_TODAY',
      analytics: {
        SCREEN: screenName,
      },
    });
    setIsLogged(true);
  }, [isLogged, screenName]);
};
